




















import { getJsSdkConfig } from '@/api/pay'
import { SOUGOU_WXJSDK_APPID as WXJSDK_APPID } from '@/config/dataMap'
import { createPayOrder } from '@/services/pay/h5'
import { WX_SCOPE, wxOauth } from '@/services/pay/wxAuth'
import { scanQrReportByService, getH5ReportParamAndcheckCanCreateOrder } from '@/api/pdfPay'
import wx from 'weixin-js-sdk'
import { formatDate } from '@/utils/shared'
import { nextTick } from '@vue/composition-api'
import { useEasyCounter, useReporter } from '@crab/veekd'

// 支付状态
const PAY_RESULT = {
  enterH5: 3, // 进入H5，
  resetPay: 7, // 重新支付
}

// 订单创建状态
const ORDER_STATUS = {
  success: 1, // 成功
  havePay: 2, // 已经购买过该套餐
  isLifeMember: 3, // 已是终生会员，联系工作人员购买
}

// 产品ID
const PRODUCT_ID = {
  pdfVip: 13, // 极光pdf独立版
}

// h5页面加载时长上报版本号
const REPORT_VERSION = '1'

// easyCounter metric
const EASYCOUNTER_METRIC = {
  loadTimeGauge: 'wechat_h5_page_load_time', // 加载时长上报指标
  enterCount: 'wechat_h5_pay_page_count', // 进入页面的次数
}

// sessionStorage参数枚举
const SESSION_STORAGE_PARAMS = {
  isReturn: 'isReturn', // 页面返回
  enterTime: 'enterTime', // 进入时间
}

/**
 * 移动端中间支付页
 */
export default {
  name: 'h5Pay',

  data () {
    return {
      payParams: {}, // 支付的参数
      common: {},
      code: '', // 登录的code,
      pageShow: {
        orderId: '', // 订单ID
        productName: '', // 下单的套餐名称
        payMoney: 0, // 支付金额
        payTime: 0, // 支付时间
      },
      isRepay: 0, // 是否点击重新支付,
      isCanPay: true, // 是否支持下单,
      orderInfo: null, // 存储订单信息， 以供【重新支付】使用
      isWeChatEnvironment: true, // 是否微信环境
      floatPage: false, // 是否微信悬浮页
      certificateId: '', // 套餐凭证ID
      initEnterTime: '', // 首次进入页面的时间
    }
  },

  async created () {
    // 判断是否是回退
    const isCloseWindow = this.handleIsReturnWindow()
    // 获取微信登录后授权的code， 如果是微信登录这个code会携带过来
    this.code = this.$route.query.code || ''

    /**
     * 回退 - isCloseWindow && !this.code
     * 刷新 - isCloseWindow && this.code
     */
    if (isCloseWindow && !this.code) {
      // 回退
      this.initJsSdkConfig(() => {
        wx.closeWindow()
        setTimeout(() => {
          this.floatPage = true
        }, 1000)
      })
      return
    }

    try {
      this.cacheTimeOfEnterPage()
      if (this.code) {
        // easyCounter统计进入页面次数
        useEasyCounter().count(EASYCOUNTER_METRIC.enterCount, 1, { tryno: '3068' })

        // 获取凭证ID
        this.certificateId = this.$route.query.cert_id

        // 判断支付支持用户支付该订单
        await this.getCanCreateOrder()
      } else {
        // 不存在微信登录授权的code，走静默登录
        sessionStorage.removeItem(SESSION_STORAGE_PARAMS.isReturn)
        wxOauth(WXJSDK_APPID, WX_SCOPE.base, 'silent')
      }
    } catch (err) {
      console.log('error:', err)
    }
  },

  mounted () {
    document.title = 'PDF编辑转换器 - 微信支付'
  },

  methods: {
    // 判断用户是否被允许支付该套餐
    async getCanCreateOrder () {
      try {
        const res = await getH5ReportParamAndcheckCanCreateOrder({
          certificate: this.certificateId
        })

        if (res.status != ORDER_STATUS.success) {
          let toastText = '该订单已支付'
          // @ts-ignore
          if (res.status == ORDER_STATUS.isLifeMember) {
            toastText = '请联系极光PDF工作人员进行购买'
          }
          this.handleError({ toastText })
        } else {
          this.initReportParams(res)
        }
      } catch (err) {
        console.log('error in judgement:', err)
      }
    },

    /**
     * 初始化上报参数
     */
    initReportParams (res: Object) {
      // @ts-ignore
      const client_extra = res.client_extra
      // 获取上报数据
      this.payParams = client_extra.payParams
      this.common = client_extra.common

      // 上报
      this.scanQrReport()

      // 初始化支付套餐名称&金额
      this.pageShow.productName = this.payParams.pay_setting_name
      this.pageShow.payMoney = this.payParams.pay_setting_price

      // 存在微信授权的code
      this.payParams.wx_oauth_code = this.code
      this.initJsSdkConfig(this.genPayOrder)
    },

    // 数据上报
    async scanQrReport () {
      try {
        await scanQrReportByService({
          ...this.payParams,
          pay_result: this.isRepay ? String(PAY_RESULT.resetPay) : String(PAY_RESULT.enterH5),
          common: this.common
        })
      } catch (err) {
        console.log('error in report:', err)
      }
    },

    // 初始化JS-SDK的配置
    async initJsSdkConfig (callback: Function) {
      const { open_id, token, tryno } = this.common
      const res = await getJsSdkConfig({
        common: {
          open_id,
          token,
          tryno
        },
        url: window.location.href
      })

      // 初始化配置信息
      wx.config({
        debug: false,
        appId: WXJSDK_APPID,
        // @ts-ignore
        timestamp: res.timestamp,
        // @ts-ignore
        nonceStr: res.nonceStr,
        // @ts-ignore
        signature: res.signature,
        jsApiList: ['chooseWXPay'],
      })

      // 配置信息验证成功后走ready
      wx.ready(() => {
        // 判断当前客户端版本 是否支持指定的JS接口
        wx.checkJsApi({
          jsApiList: ['chooseWXPay'],
          success: (res) => {
            // 成功执行回调
            callback && callback()
          }
        })
      })
    },

    // 生成支付订单
    genPayOrder () {
      try {
        createPayOrder(this.payParams, this.common).then(res => {
          this.handlePayData(res)
        })
      } catch (err) {
        console.log('error:', err)
        this.handleError({ toastText: '创建订单异常，稍后请重试' })
      }
    },

    // 处理生成支付订单的数据
    handlePayData (res) {
      if (res.resp_common?.ret !== 0) {
        this.handleError({ toastText: '创建订单异常，稍后请重试' })
        return
      }

      if (res.entrust_url) {
        // 签约套餐
        location.href = res.entrust_url
      } else {
        // 保存支付订单号 & 时间
        this.pageShow.orderId = res.order_id
        this.pageShow.payTime = formatDate(Number(res.time_stamp), 'yyyy-MM-dd hh:mm:ss')
        // 存储订单信息
        this.orderInfo = res
        // 等页面更新后再去调WX支付接口
        nextTick(() => {
          this.payByWX(res)
          try {
            this.reportPageLoader()
          } catch (error) {
            console.log('report error:', error)
          }
        })
      }
    },

    /**
     * 进行微信支付
     * @param {object} res
     */
    payByWX (res) {
      // 调起微信支付
      wx.chooseWXPay({
        timestamp: Number(res.time_stamp),
        nonceStr: res.nonce_str,
        package: res.package,
        signType: 'MD5',
        paySign: res.pay_sign,
        success: () => {
          wx.closeWindow()
        },
        fail: () => {
          wx.closeWindow()
        },
        cancel: () => { }
      })
    },

    // 重新支付
    rePayment () {
      this.isRepay = true
      // 上报
      this.scanQrReport()
      this.payByWX(this.orderInfo)
    },

    /**
     * 出错提示方法封装
     * {
     *    toastText: 错误提示文本
     *    toastDuration: toast显示时长
     *    isCloseWindow: 是否关闭窗口
     * }
     */
    handleError ({
      toastText = '出错了，稍后请重试',
      toastDuration = 3000,
      isCloseWindow = true
    }) {
      this.$toast(toastText, { toastDuration })
      setTimeout(() => {
        isCloseWindow && wx.closeWindow()
        // 关闭页面时，清除缓存
        isCloseWindow && sessionStorage.clear()
      }, toastDuration)
    },

    // 判断是否关闭页面
    handleIsReturnWindow () {
      const isReturn = sessionStorage.getItem(SESSION_STORAGE_PARAMS.isReturn)

      if (!isReturn) {
        sessionStorage.setItem(SESSION_STORAGE_PARAMS.isReturn, String(new Date().getTime()))
        return false
      }
      return true
    },

    // 缓存首次进入支付中间页的时间
    cacheTimeOfEnterPage () {
      // 首次进入页面，保存时间
      this.initEnterTime = sessionStorage.getItem(SESSION_STORAGE_PARAMS.enterTime)
      if (!this.initEnterTime) {
        sessionStorage.setItem(SESSION_STORAGE_PARAMS.enterTime, String(new Date().getTime()))
      }
    },

    // 上报页面加载时间
    reportPageLoader () {
      const endTime = new Date().getTime()

      // 时间差 - 秒级
      const timeDiffInSecond = (endTime - Number(this.initEnterTime)) / 1000

      // easyCounter加载时长上报
      useEasyCounter().gauge(EASYCOUNTER_METRIC.loadTimeGauge, timeDiffInSecond, { tryno: '3068' })

      // 报表上报页面加载时长
      this.reportPageLoaderTime(timeDiffInSecond)
      sessionStorage.removeItem(SESSION_STORAGE_PARAMS.enterTime)
    },

    // 报表 - H5页面加载时长上报
    reportPageLoaderTime (pageLoadTime: Number) {
      // 测试上报的url
      const crab_infoc_url = this.getCrabInfocReportUrl()

      // 公共上报字段
      const commomInfo = {
        uuid: this.common.uuid,
        tid1: this.common.tid1,
        tid2: this.common.tid2,
        tod1: this.common.tod1,
        tod2: this.common.tod2,
        type: 0,
        tryno: this.common.tryno,
        iid: 0,
        collect_time: 0,
        lastver: 0,
        svrid: this.common.uuid,
        wtod2: '',
        usertype_public: 0,
      }

      // 业务字段
      const initData = {
        product_no: 1, // Infoc毒霸产品
        public_index: 6, // duba_public的index
        product_id: PRODUCT_ID.pdfVip,
        url: window.location.href.split('?')[0] || '',
        openid: this.common.open_id,
        load_time: String(pageLoadTime),
        days: this.payParams.install_days,
        ver: REPORT_VERSION
      }

      const reportObj = useReporter(crab_infoc_url, 'duba_jgpdfpay_loadtime:8536 product_id:int url:string openid:string load_time:string days:string ver:string', initData, commomInfo)
      reportObj.report(initData)
    },

    // 获取crab_infoc上报的url
    getCrabInfocReportUrl () {
      const protocol = location.protocol || 'http:'
      let crab_infoc_url = `${protocol}//infoc2.duba.net/g/v1/`
      if (process.env.VUE_APP_STAGE === 'test') {
        crab_infoc_url = `${protocol}//121.37.228.14/g/v1/`
      }
      return crab_infoc_url
    }
  },
}
